import { render, staticRenderFns } from "./VModalClose.vue?vue&type=template&id=19fd5f90&"
import script from "./VModalClose.vue?vue&type=script&lang=ts&"
export * from "./VModalClose.vue?vue&type=script&lang=ts&"
import style0 from "./VModalClose.vue?vue&type=style&index=0&id=19fd5f90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports